<template>
	<div class="page">
		<!-- 页面路径 -->
		<div class="pageRouter f-ct">
			当前位置：<span @click="link('/home')">首页</span>
			<el-image :src="require('@/static/icon23.png')"></el-image>
			<span class="blue">专业培训</span>
		</div>
		<!-- 内容 -->
		<div class="pagecon f-bct animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<!-- 分类 -->
			<div class="lCat">
				<el-image class="titimg" :src="require('@/static/icon26.png')"></el-image>
				<div class="itm" :class="catItem.id==item.id?'a':''" @click="pageNum=1,changeCat(item)" v-for="(item,index) in catArr">
					<p>{{item.name}}</p>
					<el-image class="i1" :src="require('@/static/icon19h.png')"></el-image>
					<el-image class="i2" :src="require('@/static/icon19.png')"></el-image>
				</div>
			</div>
			<div class="rList">
				<!-- 搜索 -->
				<div class="seach f-ct">
					<div class="iptBox f-ct">
						<div class="sel">
							<el-select v-model="value" placeholder="请选择筛选类型">
								<el-option
									v-for="item in options"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
						<div class="bor"></div>
						<div class="ipt">
							<el-input type="text" v-model="keyword" placeholder="请输入搜索关键词"></el-input>
						</div>
					</div>
					<div class="seachBtn f-ct">
						<div @click="pageNum=1,articleList(catItem.id)">搜索</div>
						<div @click="keyword='',pageNum=1,articleList(catItem.id)">重置</div>
					</div>
				</div>
				<!-- 内容 -->
				<div class="catMsg" v-if="catItem.isPage">
					<div class="catcon">
						<div v-html="catItem.content"></div>
					</div>
				</div>
				<!-- 列表 -->
				<div class="list" v-if="!catItem.isPage">
					<div class="tit f-ct">
						<div class="bor"></div>
						<p>{{catItem.name}}</p>
					</div>
					<div class="zw" v-if="!txtList.length">
						<el-image :src="require('@/static/zw.png')"></el-image>
						<p>暂无相关数据...</p>
					</div>
					<div class="itm f-bct" @click="link('/dynamicMsg',{id:item.id})" v-for="(item,index) in txtList">
						<div class="line1">{{item.title}}</div>
						<div class="time">{{quSFM(item.createTime)}}</div>
					</div>
					<div class="fenye">
					<el-pagination
					background
					hide-on-single-page
					layout="prev, pager, next,jumper"
					@current-change="goPage"
					:page-size="pageSize"
					:total="total">
					</el-pagination>
					</div>					
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { articlecategoryList,articleList } from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			catArr:[],
			catItem:'',
			txtList:[],
			// 分页
			pageNum:1,
			pageSize:10,
			total:0,
			// 筛选
			keyword:'',
			options: [
				{
					value: '选项1',
					label: '全部分类'
				}, 
			],
			value: '',
		}
	},
	mounted() {
		this.articlecategoryList()
	},
	methods:{
		// 切换分类
		changeCat(item){
			this.catItem = item
			if(!item.isPage){
				this.articleList(item.id)
			}
		},
		// 分类列表
		async articlecategoryList(){
			let res = await articlecategoryList({parentId:7});
			if(res.code==200){
				this.catArr = res.rows
				this.catItem = res.rows[0]
				if(!res.rows[0].isPage){
					this.articleList(res.rows[0].id)
				}
			}else{this.Tips(res.msg,'error')}
		},
		// 文章列表
		async articleList(id){
			var data = {
				categoryId:id,
				pageSize: this.pageSize,
				pageNum: this.pageNum,
			}
			if(this.keyword){
				data.title = this.keyword
			}
			let res = await articleList(data);
			if(res.code==200){
				if(this.pageNum==1){
					this.total = res.total
				}
				this.txtList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转页
		goPage(e){
			// console.log(e)
			this.pageNum = e
			this.articleList(this.catItem.id)
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.page{
	width: 1200px;
	margin: auto;
	padding-bottom: 20px;
}
.pageRouter{
	padding: 24px 0;
	font-size: 16px;
	span{
		color: #666666;
		cursor: pointer;
	}
	.el-image{
		width: 16px;
		height: 16px;
		margin: 0 3px;
	}
	.blue{
		color: #3B6492;
	}
}
.pagecon{
	align-items: stretch;
	.lCat{
		width: 294px;
		background: #fff;
		padding-bottom: 40px;
		.titimg{
			width: 294px;
			height: 80px;
		}
		.itm{
			cursor: pointer;
			height: 62px;
			margin: 0 24px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1px dashed #BBBBBB;
			.el-image{
				width: 14px;
				height: 14px;
			}
			.i1{
				display: none;
			}
			.i2{
				display: block;
			}
			p{
				font-size: 16px;
			}
			&:hover{
				p{
					color: #3B6492;
					font-weight: bold;
				}
				.i1{
					display: block;
				}
				.i2{
					display: none;
				}
			}
		}
		.a{
			p{
				color: #3B6492;
				font-weight: bold;
			}
			.i1{
				display: block;
			}
			.i2{
				display: none;
			}
		}
	}
	.rList{
		width: 882px;
		.seach{
			width: 100%;
			height: 70px;
			background: #fff;
			padding: 15px 16px;
			.iptBox{
				width: 656px;
				height: 40px;
				border: 1px solid #DDDDDD;
				margin-right: 12px;
				.sel{
					.el-select{
						width: 121px;
					}
					::v-deep .el-input__inner{
						border: none;
						background: transparent;
					}
				}
				.bor{
					width: 1px;
					height: 20px;
					background: #DDDDDD;
				}
				.ipt{
					width: calc(100% - 182px);
					.el-select{
						width: 100%;
					}
					::v-deep .el-input__inner{
						border: none;
						background: transparent;
					}
				}
			}
			.seachBtn{
				div{
					width: 85px;
					height: 40px;
					border: 1px solid #DDDDDD;
					font-size: 16px;
					color: #666666;
					text-align: center;
					line-height: 38px;
					cursor: pointer;
					&:first-child{
						background: #3B6492;
						border: 1px solid #3B6492;
						color: #fff;
						margin-right: 12px;
					}
				}
			}
		}
		.catMsg{
			padding: 24px 24px;
			background: #fff;
			margin-top: 20px;
			.catcon{
				height: 800px;
				overflow-y: scroll;
			}
		}
		.list{
			padding: 0 24px;
			background: #fff;
			margin-top: 20px;
			padding-bottom: 22px;
			.tit{
				padding-top: 24px;
				padding-bottom: 14px;
				margin-bottom: 6px;
				border-bottom: 1px solid #EEEEEE;
				.bor{
					width: 3px;
					height: 24px;
					border-radius: 3px;
					margin-right: 10px;
					background: #3B6492;
				}
				p{
					font-size: 22px;
					font-weight: bold;
				}
			}
			.itm{
				border-bottom: 1px dashed #BBBBBB;
				padding: 16px 0;
				cursor: pointer;
				&:hover{
					.line1{
						color: #3B6492;
					}
				}
				.line1{
					width: calc(100% - 105px);
					font-size: 16px;
				}
				.time{
					width: 105px;
					text-align: right;
					font-size: 14px;
					color: #9A9DA7;
				}
			}
		}
		.fenye{
			display: flex;
			align-items: center;
			justify-content: flex-end;
			margin-top: 26px;
			.i1{
				width: 24px;
				height: 24px;
				margin-right: 6px;
			}
			.fyitm{
				width: 32px;
				height: 32px;
				font-size: 12px;
				text-align: center;
				line-height: 32px;
				margin-right: 6px;
				border-radius: 4px;
			}
			.a{
				background: #3B6492;
				color: #fff;
			}
			.i2{
				width: 24px;
				height: 24px;
				margin-right: 19px;
			}
			.linkPage{
				p{
					font-size: 12px;
				}
				.ipt{
					margin: 0 6px;
					width: 42px;
					height: 32px;
					border-radius: 4px;
					background: #F4F4F4;
					.el-select{
						width: 100%;
					}
					::v-deep .el-input__inner{
						border: none;
						background: transparent;
					}
				}
			}
		}
	}
}
</style>